import type { ReactNode } from 'react'
import { faWrench } from '@fortawesome/pro-solid-svg-icons'
import { Icon, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'

export const PendingDots = () => (
  <span className="flex items-center gap-1" aria-label="In progress">
    {[0, 160, 320].map((delay) => (
      <span
        key={delay}
        className="block h-1.5 w-1.5 rounded-full bg-neutral-400 animate-pulse"
        style={{ animationDelay: `${delay}ms` }}
      />
    ))}
  </span>
)

interface StatusRowProps {
  label: string
  pending: boolean
  trailing: ReactNode
  children?: ReactNode
  singleLine?: boolean
}

export const StatusRow = ({
  label,
  pending,
  trailing,
  children,
  singleLine = false,
}: StatusRowProps) => {
  const hangGlyphs = !pending && !singleLine

  return (
    <div className="my-2 flex flex-col rounded-xl border border-neutral-200 bg-neutral-25 px-3.5 py-2.5">
      <div
        className={mtc(
          'flex gap-2.5',
          hangGlyphs ? 'items-start' : 'items-center'
        )}
      >
        <Icon
          icon={faWrench}
          className={mtc(
            'text-sm text-neutral-400 shrink-0',
            hangGlyphs && 'mt-0.5'
          )}
        />
        <Text
          variant={TypographyStyles.BODY_SM}
          color={TextColors.MUTED}
          className="flex-1 leading-snug"
        >
          {label}
        </Text>
        <span
          className={mtc(
            'flex shrink-0 items-center gap-3',
            hangGlyphs && 'mt-0.5'
          )}
        >
          {trailing}
        </span>
      </div>
      {children}
    </div>
  )
}
